import BigNumber from 'bignumber.js';

export const getRemainingCollateral = ({
  collateral,
  collateralPrice,
  fundingFee,
  holdingFee,
}: {
  collateral: BigNumber;
  fundingFee: BigNumber;
  holdingFee: BigNumber;
  collateralPrice: BigNumber;
}) => {
  return collateral.minus(fundingFee).minus(holdingFee).times(collateralPrice);
};
